import _styled from "styled-components";
var _excluded = ["style", "renderLoading", "renderError", "renderLoadMore"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType, omitKeys } from '@adsk/alloy-helpers';
import ProgressRing from '@adsk/alloy-progress-ring';
import DefaultError from './layout/DefaultError';
import DefaultLoadMore from './layout/DefaultLoadMore';
import useLoadMoreData from './useLoadMoreData';

var LoadMoreData = function LoadMoreData(_ref) {
  var style = _ref.style,
      _ref$renderLoading = _ref.renderLoading,
      renderLoading = _ref$renderLoading === void 0 ? function () {
    return /*#__PURE__*/React.createElement(ProgressRing, {
      "data-testid": "loading"
    });
  } : _ref$renderLoading,
      _ref$renderError = _ref.renderError,
      renderError = _ref$renderError === void 0 ? function (props) {
    return /*#__PURE__*/React.createElement(DefaultError, props);
  } : _ref$renderError,
      _ref$renderLoadMore = _ref.renderLoadMore,
      renderLoadMore = _ref$renderLoadMore === void 0 ? function (props) {
    return /*#__PURE__*/React.createElement(DefaultLoadMore, props);
  } : _ref$renderLoadMore,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useLoadMoreData = useLoadMoreData(props),
      isLoading = _useLoadMoreData.isLoading,
      hasError = _useLoadMoreData.hasError,
      inViewRef = _useLoadMoreData.inViewRef,
      onLoad = _useLoadMoreData.onLoad,
      onRetry = _useLoadMoreData.onRetry;

  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, omitKeys(props, ['isLoading', 'hasError', 'isAuto', 'onLoad', 'onRetry']), {
    $_css: [{
      display: 'flex',
      alignItems: 'center'
    }, style]
  }), function () {
    if (hasError) {
      return renderError({
        onRetry: onRetry
      });
    }

    if (isLoading) {
      return renderLoading();
    }

    return renderLoadMore({
      inViewRef: inViewRef,
      onLoad: onLoad
    });
  }());
};

LoadMoreData.propTypes = {
  /* A callback function which is responsible for fetching more data to pump into the
   * table. It should return a promise that resolves after the data loading is complete.
   * Depending on whether `isAuto` is true or false, this callback will be triggered via
   * click or as soon as this component enters the viewport.
   */
  onLoad: PropTypes.func.isRequired,

  /* An optional callback function which will be used when an error is present.
   * Essentially onLoad is called initially, and if it fails, the onRetry callback will be
   * used. If onRetry is omitted, the onLoad function will do double duty and fill in the
   * onRetry gap.
   */
  onRetry: PropTypes.func,

  /* A flag to determine if a user click event is required to load more or if the
   * component should load more automatically (i.e. as soon as the component comes into
   * view).
   */
  isAuto: PropTypes.bool,

  /* An optional boolean flag which would allow consumers to control the error state
   * rather than depend on the internal error handling.
   */
  hasError: PropTypes.bool,

  /* An optional boolean flag which would allow consumers to control the loading state
   * rather than depend on the internal loading.
   */
  isLoading: PropTypes.bool,

  /* A function to render custom jsx for the loading state */
  renderLoading: PropTypes.func,

  /* A function to render custom jsx for the initial load more state */
  renderLoadMore: PropTypes.func,

  /* A function to render custom jsx for the error state */
  renderError: PropTypes.func,

  /* Styles applied to the root element */
  style: stylePropType,

  /* Class applied to the root element */
  className: PropTypes.string
};
export default LoadMoreData;

var _StyledDiv = _styled("div").withConfig({
  displayName: "LoadMoreData___StyledDiv",
  componentId: "sc-rg0c65-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=LoadMoreData.js.map